import Seo from "@/components/Seo";
import { Eyebrow, H2, Body, Section } from "@/components/Type";
import { useWaitlist } from "@/context/waitlist";

const Para = ({ children }) => (
  <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#8e8a80]">{children}</p>
);

export default function FounderPage() {
  const openWaitlist = useWaitlist();

  return (
    <>
      <Seo
        title="Vikram Chawla — Founder | W8ED"
        description="Why I built W8ED — Vikram Chawla, Founder of W8ED."
        path="/founder"
      />
      <section className="px-6 pb-20 pt-32 sm:pt-40">
        <div className="mx-auto max-w-6xl">
          <Eyebrow>Founder</Eyebrow>
          <h1 className="mt-8 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-[#f5f2ea] sm:text-6xl">
            VIKRAM CHAWLA
          </h1>
          <p className="mt-4 font-mono text-[11px] tracking-[0.3em] uppercase text-[#57534a]">
            Founder, W8ED
          </p>
        </div>
      </section>

      <Section>
        <H2>WHY I BUILT W8ED.</H2>
        <Para>
          I've spent much of my career thinking about food — what people eat, why they eat it, and
          how food can be designed to work better for people.
        </Para>
        <Para>But the deeper I went, the clearer something became: nutrition doesn't exist independently.</Para>
        <Para>
          What we eat interacts with metabolism. Metabolism interacts with movement. Movement
          affects muscle. Muscle affects resilience. Sleep affects almost everything. Stress changes
          behaviour. Recovery changes adaptation. And behaviour determines what we actually repeat.
        </Para>
        <Para>That is where W8ED began.</Para>
        <Para>Not with a product. Not with an app. With a question:</Para>
        <p className="mt-8 max-w-2xl border-l-2 border-[#C9A227] pl-6 font-display text-xl font-bold leading-snug text-[#b8b3a6] sm:text-2xl">
          Can we build a better system for human health?
        </p>
      </Section>

      <Section>
        <Eyebrow>The Philosophy</Eyebrow>
        <H2 className="mt-6">DISCIPLINE &gt; DOPAMINE.</H2>
        <Para>
          Dopamine is not the enemy. It is part of how we are built. The problem is the imbalance —
          environments engineered for immediate reward, set against outcomes that only arrive later.
        </Para>
        <Para>
          Discipline is not punishment. It is the ability to repeatedly choose a future outcome over
          an immediate reward. That choice, repeated, is what the whole system is built on.
        </Para>
      </Section>

      <Section>
        <Eyebrow>The Vision</Eyebrow>
        <Para>
          "I don't think better health needs more information. We already have more information
          than ever.
        </Para>
        <Para>
          I think we need better systems for turning what we know into what we repeatedly do.
          That's what I'm building with W8ED."
        </Para>
      </Section>

      <section className="border-t border-[#1f1e1a] px-6 py-32 text-center sm:py-40">
        <p className="font-mono text-[10px] tracking-[0.35em] uppercase text-[#57534a]">
          You are what you repeat.
        </p>
        <p className="mt-4 font-mono text-[10px] tracking-[0.35em] uppercase text-[#C9A227]">
          Discipline &gt; Dopamine.
        </p>
        <button
          type="button"
          data-testid="founder-join"
          onClick={openWaitlist}
          className="mt-10 border border-[#3a3524] px-8 py-4 font-mono text-[11px] tracking-[0.3em] uppercase text-[#C9A227] transition-colors hover:border-[#C9A227]"
        >
          JOIN THE W8LIST
        </button>
      </section>
    </>
  );
}
